import React from "react";

export function TextInPill(props) {
    const estilo = props.style || {};
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ marginInline: 1 }} title={props.title}>
            <div
                style={{
                    borderRadius: 3,
                    paddingInline: 2,
                    width: estilo.width || "100%",
                    color: props.color || "#222",
                    background: props.background,
                    ...estilo,
                }}
            >
                {props.text}
            </div>
        </div>
    );
}
